export default __webpack_public_path__ + "static/media/00.27674bde.jpg";